import { useTranslation } from 'next-i18next'
import heartArms from 'assets/home-heart-arms.svg'
import maskHand from 'assets/home-mask-hand.svg'
import sun from 'assets/home-sun.svg'
import UseCasesBlock from 'blocks/UseCases'

export function UseCases() {
  const { t } = useTranslation('home.page')

  return (
    <UseCasesBlock
      title={t('usecases.title')}
      color="white"
      useCases={[
        {
          title: t('usecases.start.title'),
          image: {
            image: maskHand,
            alt: '',
          },
        },
        {
          title: t('usecases.rse.title'),
          image: {
            image: sun,
            alt: '',
          },
        },
        {
          title: t('usecases.marketing.title'),
          image: {
            image: heartArms,
            alt: '',
          },
        },
      ]}
    />
  )
}
